/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */

import React from 'react';

// @ts-expect-error
import * as UserActions from 'actions/UserActions';
import Tooltip from 'ui-library/bs/Tooltip';

interface Props {
  inviteEmail: string;
  showDismiss?: boolean;
}

class PendingInvites extends React.Component<Props> {
  static defaultProps = {
    showDismiss: true,
  };

  dismissOrgInvites = (): void => {
    UserActions.dismissAllOrgInvites();
  };

  override render(): JSX.Element {
    return (
      <div className="alert alert-info u-no-spacing-bottom">
        {this.props.showDismiss ? (
          <Tooltip title="Click to hide forever">
            <button type="button" className="close" onClick={this.dismissOrgInvites}>
              ×
            </button>
          </Tooltip>
        ) : undefined}
        <strong>You have pending invites!</strong>
        {' Look for an email from '}
        {this.props.inviteEmail}
        {' and click "Join" to accept.'}
      </div>
    );
  }
}

export default PendingInvites;
